import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=5aa75393&scoped=true&lang=pug&"
import script from "./Page.vue?vue&type=script&lang=js&"
export * from "./Page.vue?vue&type=script&lang=js&"
import style0 from "./Page.styl?vue&type=style&index=0&id=5aa75393&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa75393",
  null
  
)

export default component.exports